import React from 'react'
import styles from "./SelectPayerModal.styles"
import Popup from '../../../../components/popup/Popup'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown'
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import Button from '../../../../components/button/Button'

const SelectPayerModal = ({
    title = "Bulk W8 Request",
    bodyText,
    isOpen,
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: "Submit",
        confirmationButtonStyles: {},
        confirmationButtonType: BUTTON_TYPE.PRIMARY,
    },
    cancelButtonProps = {
        onCancelCb: () => { },
        onCloseCb: () => { },
        cancelButtonText: "Cancel",
        cancelButtonStyles: {},
        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
    },
    customStyle = {},
    isClose = true,
    onSelectCb = () => { },
    options,
    name = "",
    value = { label: "", value: "" },
    rules,
    errors,
    formSubmitted = false,
    placeHolder,
    onSearchInputChangeCb = () => { },
    onDropdownTouchedToBottomCb = () => { },
    clearSearchTextCb = () => { }
}) => {
    return (
        <Popup title={title} onCloseCb={isClose ? cancelButtonProps.onCancelCb : cancelButtonProps.onCloseCb} isPopupOpen={isOpen} childrenStyles={{ ...styles.popupModal, ...customStyle }}>
            <div style={styles.bodyContainer}>

                {bodyText && <span>{bodyText}</span>}

                <div style={styles.selectForms}>
                    <SelectDropdown
                        name={name}
                        placeHolder={placeHolder}
                        value={value}
                        onSelectCb={onSelectCb}
                        options={options}
                        rules={rules}
                        errors={errors}
                        formSubmitted={formSubmitted}
                        onSearchInputChangeCb={onSearchInputChangeCb}
                        onDropdownTouchedToBottomCb={onDropdownTouchedToBottomCb}
                        clearSearchTextCb={clearSearchTextCb}
                    />
                </div>
            </div>

            <HorizontalSeparator />

            <div style={styles.footer}>

                {confirmationButtonProps.confirmationButtonText && <div onClick={confirmationButtonProps.onConfirmationCb}>
                    <Button
                        type={confirmationButtonProps.confirmationButtonType}
                        style={{ ...confirmationButtonProps.confirmationButtonStyles, ...styles.buttons }}
                    >
                        {confirmationButtonProps.confirmationButtonText}
                    </Button>
                </div>}


                <div onClick={cancelButtonProps.onCancelCb}>
                    <Button
                        type={cancelButtonProps.cancelButtonType}
                        style={{ ...cancelButtonProps.cancelButtonStyles, ...styles.buttons }}
                    >
                        {cancelButtonProps.cancelButtonText}
                    </Button>
                </div>

            </div>
        </Popup>
    )
}

export default SelectPayerModal
